import {
  ModalContainer,
  InlineFormContainer,
} from '@stepstone-fragment/login-registration';
import { EndpointClient } from 'types/endpoint';

export const containersClient: EndpointClient[] = [
  {
    name: 'modal',
    serverRender: false,
    container: ModalContainer,
  },
  {
    name: 'form',
    serverRender: true,
    container: InlineFormContainer,
  },
];
